import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { CITY_FEATURE, CityState, StateWithCity } from '../city-state';

export const getCityState: MemoizedSelector<StateWithCity, CityState> = createFeatureSelector<CityState>(CITY_FEATURE);
